module.exports = __webpack_public_path__ + "static/img/weixuanzhongmoshi.png@2x.a6e1e56f.png";